<template>
  <div>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate">
        <a
          href=""
          v-on:click.prevent="topage('/home/memberManagement/playRecord')"
          >游玩记录</a
        >
        <a
          href=""
          v-on:click.prevent="topage('/home/memberManagement/userPullsNew')"
          >用户拉新</a
        >
        <a v-on:click.prevent="showModal">绑定上级</a>
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>
<script>
import {
  userDetailsCouponsList,
  storeTixianWalletList,
} from "@/api/storeApi.js";

const columns = [
  {
    title: "用户uid",
    dataIndex: "userUid",
    sorter: true,
  },
  {
    title: "券码",
    dataIndex: "gender",
  },
  {
    title: "手机号码",
    dataIndex: "phone",
  },
  {
    title: "优惠券有效期至",
    dataIndex: "effectiveDate",
    sorter: true,
  },
  {
    title: "使用状态",
    dataIndex: "useStatus",
    sorter: true,
  },
  {
    title: "使用订单号",
    dataIndex: "useOrderNo",
    sorter: true,
  },
  {
    title: "领取时间",
    dataIndex: "name",
    sorter: true,
    width: "10%",
    scopedSlots: { customRender: "memberStatus" },
  },
  {
    title: "使用时间",
    dataIndex: "useTime",
    sorter: true,
  },
  {
    title: "失效时间",
    dataIndex: "updateTime",
    sorter: true,
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {},
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getUserDetailsCouponsList();
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
    },

    getUserDetailsCouponsList() {
      let objId = this.$route.query.objId;
      userDetailsCouponsList({ limit: 10, page: 1, discountId: objId }).then(
        (res) => {
          this.data = res.data;
        }
      );
    },
    goBack() {
      this.$router.push("/home/offerManagement/offerManagementHome");
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/marketingManagement/offerManagement/usageDetails/usageDetailsHomeContent.vue